<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 18C14.411 18 18 14.411 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM6.543 10.043L9.293 7.293C9.488 7.098 9.744 7 10 7C10.256 7 10.512 7.098 10.707 7.293L13.457 10.043C13.848 10.434 13.848 11.066 13.457 11.457C13.066 11.848 12.434 11.848 12.043 11.457L10 9.414L7.957 11.457C7.566 11.848 6.934 11.848 6.543 11.457C6.152 11.066 6.152 10.434 6.543 10.043Z"
            fill="currentColor"
        />
    </svg>
</template>
